import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["checkboxLabel", "checkboxLabelledby", "checked", "className", "disabled", "fwdRef", "hideBorder", "indeterminate", "invalid", "onClick", "th"];
import React, { forwardRef, useState } from 'react';
import { Checkbox, deprecated } from '@op/opds.opux';
import { buildVersionedClassNames } from '@op/opds.opux-utilities';
/**
 * _An interactive table cell that enables the selection of its checkbox._
 *
 * ***
 *
 * The component is displayed as a table cell with a checkbox inside of it.
 * The whole cell is interactive providing a better click/touch target than the
 * small checkbox inside of it alone would.
 *
 * The component is meant to be used as the first cell of table rows.
 * It can be used independently on the table rows to provide an
 * interactive selection cell or it can be used within a [`TableRowSegment`](#/Lists%20%26%20Tables/TableRowSegment)
 * to provide the interactivity for the whole body row segment with the mouse and touch use.
 *
 * Additional props (including `ref`) will be forwarded to the wrapping HTML element.
 */
export const TableCheckboxCell = _ref => {
  let {
      checkboxLabel,
      checkboxLabelledby,
      checked,
      className,
      disabled,
      fwdRef,
      hideBorder,
      indeterminate,
      invalid,
      onClick,
      th = false
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (th) {
    deprecated('The th property of the TableCheckboxCell is deprecated as of August 2024 and will be removed in OPUX 7.');
  }
  const [active, setActive] = useState(false);
  const Tag = th ? 'th' : 'td';
  return /*#__PURE__*/React.createElement(Tag, _extends({
    className: buildVersionedClassNames('ds-table-checkbox-cell', className, {
      'ds-table-checkbox-cell__header-checkbox': th,
      'ds-table-checkbox-cell--hide-border': hideBorder,
      'ds-table-checkbox-cell--active-body-checkbox': active && !th,
      'ds-table-checkbox-cell--active-header-checkbox': active && th,
      'ds-table-checkbox-cell--disabled': disabled
    }),
    onMouseDown: () => setActive(true),
    onMouseUp: () => setActive(false),
    onMouseLeave: () => setActive(false),
    ref: fwdRef
  }, props), /*#__PURE__*/React.createElement(Checkbox, {
    "aria-label": checkboxLabel,
    "aria-labelledby": checkboxLabelledby,
    checked: checked,
    disabled: disabled,
    indeterminate: indeterminate,
    invalid: invalid,
    onClick: onClick,
    size: "tiny"
  }));
};
const Fwd = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/React.createElement(TableCheckboxCell, _extends({}, props, {
  fwdRef: ref
})));
Fwd.displayName = 'TableCheckboxCell';
export default Fwd;